module.exports = "<ui-view></ui-view>";


//////////////////
// WEBPACK FOOTER
// ./sources/components/configurations/configurations.html
// module id = 234
// module chunks = 0